<!-- 
    가장 최근의 SnapshotData를 기준으로 Type별 Status의 현황을 보여주는 그래프

 -->

 <template>
    <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap h-80" style="margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>

        
        <div class="h-100" style="flex:3; position: relative; padding:0;">
            <apexchart v-if="showGraph" id="chart"
            width="100%" height="100%" ref="apexchart" 
            :options="chartOptions"
                :series="series" />
        </div>
    </b-row>
    <!-- <b-row class="w-100 d-flex justify-content-center align-items-center flex-nowrap" :class="isFlexible ? 'h-100' : 'h-80'" style="margin: 0;">
        <loading :active="loading"
             :is-full-page="false"/>
        <div v-if="series" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        
        <div class="change-today-graph h-100" style="flex:3; position: relative;" :style="isFlexible ? 'padding: 20px 0;' : 'padding: 0;'">
            <apexchart v-if="series" id="chart"
            width="100%" height="100%" ref="apexchart" 
            :options="chartOptions"
                :series="series" />
        </div>
        <div v-if="isFlexible && tableData" class="d-flex align-items-center justify-content-center flex-column h-100" style="flex:1">
            <ChartTable :tableData="tableData"/>
        </div>
    </b-row> -->
</template>

<script scoped>
import VueApexCharts from "vue-apexcharts";
export default {
    name: 'StampParticipationRate',

    components: {
        apexchart: VueApexCharts,
    },
    created() {
        // this.series.forEach(item => {
        //     this.graphSeries.push(item.data);
        //     this.graphLabels.push(item.name);
        // });
        // 차트를 업데이트
        // if (this.$refs.apexchart) {
        //         this.$refs.apexchart.updateOptions({
        //             xaxis: {
        //                 categories: this.categories,
        //             },
        //         });
        //     }

        // this.chartOptions.labels = this.categories;
        this.chartOptions.xaxis.categories = [
            "출석",
            "리뷰", 
            "상품구매",
            "만보기",
            "체크인",
            "클럽 스탬프",
            "APP 설치",
            "자기정보입력", 
            "마케팅 수신활용동의",
            "단골매장 등록",
            "위치데이터 동의",
        ],
        this.showGraph = true;
    },
    data() {
        return {
            loading : false,
            showGraph: false,
            
            series: [
                    {
                        name: '참여 인원',
                        data: [
                    {
                        x: '1월',
                        y: 9512,
                        fillColor: '#142459' // 첫 번째 데이터 포인트 색상
                    },
                    {
                        x: '1월',
                        y: 8912,
                        fillColor: '#142459' // 첫 번째 데이터 포인트 색상
                    },
                    {
                        x: '2월',
                        y: 8231,
                        fillColor: '#142459' // 두 번째 데이터 포인트 색상
                    },
                    {
                        x: '3월',
                        y: 7831,
                        fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    },
                    {
                        x: '4월',
                        y: 7123,
                        fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    },
                    {
                        x: '5월',
                        y: 6931,
                        fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    },
                    {
                        x: '5월',
                        y: 6031,
                        fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    },
                    {
                        x: '5월',
                        y: 5231,
                        fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    },
                    {
                        x: '5월',
                        y: 4531,
                        fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    },
                    {
                        x: '5월',
                        y: 4031,
                        fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    },
                    {
                        x: '6월',
                        y: 1424,
                        fillColor: '#FF6666' // 세 번째 데이터 포인트 색상
                    },
                    {
                        x: '7월',
                        y: 924,
                        fillColor: '#FF6666' // 세 번째 데이터 포인트 색상
                    },
                    // {
                    //     x: '8월',
                    //     y: 2512221,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '9월',
                    //     y: 1859212,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '10월',
                    //     y: 1261212,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '11월',
                    //     y: 861231,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                    // {
                    //     x: '12월',
                    //     y: 122121,
                    //     fillColor: '#142459' // 세 번째 데이터 포인트 색상
                    // },
                ]}],
            // series: [
            //     {
            //         name: '참여 인원',
            //         data: [70212, 62511, 52361, 47872, 38778, 13212, 10023],
            //     },
            // ],
            chartOptions: {
                chart: {
                    height:'100%',
                    type: "bar",
                    stacked: true,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false,
                        // show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                plotOptions: {
                    bar: {
                        horizontal: true,
                        columnWidth: '65%',
                        // endingShape: 'rounded'
                    },
                },
                // colors: [function({value, seriesIndex, w}) {
                //     console.log(value);
                //     console.log(seriesIndex);
                //     console.log(w);
                // }],
                colors: ['#142459', '#FF6666'],
                
                dataLabels: {
                    enabled: false, // 데이터 라벨을 사용할 것인지 여부를 설정합니다.
                    style: {
                        fontSize: '10px', // 데이터 라벨의 글꼴 크기를 지정합니다.
                        colors: ['#fff'], // 데이터 라벨의 색상을 지정합니다.
                        fontWeight: 700,
                    },
                    // offsetX: 10, // 데이터 라벨을 가로 방향으로 이동시킵니다.
                    offsetY: -10, // 데이터 라벨을 세로 방향으로 이동시킵니다.
                    formatter: function (val) { // 데이터 라벨의 형식을 설정합니다.
                        return val;
                    },
                    background: { // 데이터 라벨의 배경을 설정합니다.
                        enabled: true,
                        foreColor: '#2E2E38',
                        padding: 5,
                        borderRadius: 7,
                        borderWidth: 1,
                        borderColor: '#ccc',
                        opacity: 1,
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' 명'
                        }
                    },
                    // 툴팁의 스타일 설정
                    enabled: true, // 툴팁 활성화 여부
                    shared: false, // 공유 툴팁 사용 여부 (true 또는 false)
                    // theme: 'dark', // 'dark' 또는 'light' (툴팁의 테마 설정)
                    // custom: function({ series, seriesIndex, dataPointIndex, w }) {
                    // return `<div class="custom-tooltip">${seriesIndex}</div>`;
                    // },
                    style: {
                        background: '#333',
                        color: '#fff',
                        fontSize: '14px',
                        padding: '8px',
                        borderRadius: '10px',
                        border: '1px solid #666',
                    },
                },
                xaxis: {
                    axisTicks:true,
                    min: 0,
                    max: 10000,
                    stepSize: 2500,
                    labels: {
                       formatter: function (val) {
                            const regex = /\B(?=(\d{3})+(?!\d))/g;

                            if (val >= 1000000000) {
                                return (val / 1000000000).toFixed(1).toString().replace(regex, ",") + 'B'; // 10억 이상의 경우 'billion'으로 표시
                            } else if (val >= 1000000) {
                                return (val / 1000000).toFixed(1).toString().replace(regex, ",") + 'M'; // 백만 이상의 경우 'million'으로 표시
                            } else if (val >= 1000) {
                                return (val / 1000).toFixed(1).toString().replace(regex, ",") + 'K'; // 천 이상의 경우 'thousand'으로 표시
                            }
                            return val; // 그 외의 경우 일반적으로 표시
                        }
                    }
                    
                },
                yaxis: {
                    axisTicks:true,
                    min: 0,
                    max: 100000,
                    stempSize: 20000,
                    labels: {
                       formatter: function (val) {
                            const regex = /\B(?=(\d{3})+(?!\d))/g;

                            if (val >= 1000000000) {
                                return (val / 1000000000).toFixed(1).toString().replace(regex, ",") + 'B'; // 10억 이상의 경우 'billion'으로 표시
                            } else if (val >= 1000000) {
                                return (val / 1000000).toFixed(1).toString().replace(regex, ",") + 'M'; // 백만 이상의 경우 'million'으로 표시
                            } else if (val >= 1000) {
                                return (val / 1000).toFixed(1).toString().replace(regex, ",") + 'K'; // 천 이상의 경우 'thousand'으로 표시
                            }
                            return val; // 그 외의 경우 일반적으로 표시
                        },
                        offsetY: 4,
                        style: {
                            fontSize: '14px'
                        }
                    }
                    // axisTicks:this.isFlexible,
                    // labels: {
                    //     show:this.isFlexible
                    // }
                },
                legend: {
                    show: true,
                    position:'bottom',
                    horizontalAlign: "center",
                    offsetX: 0,
                    offsetY: 3,
                    fontSize: '18px'
                    // offsetY: this.isFlexible ? 7 : 3,
                    // fontSize: this.isFlexible ? '14px' : '12px'
                },
                grid : {
                    show:false
                }
            }, 
        }
    },
    methods: {
        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '개'
        }
    },
}
</script>
<style scoped>
/* .count-label {
    font-size: 2.25rem !important;
    font-weight: 500;
}
.count-data {
    margin-top: 20px;
    font-size: 2.5rem;
    font-weight: 600;
} */

.h-80 {
    padding-top: 10px;
    height: 80%;
}
.h-90 {
    height: 90%;
}
</style>
<style>
/* 커스텀 툴팁 스타일 */
.apexcharts-tooltip {
    border-radius: 20px;
}

.change-today-graph .apexcharts-tooltip-series-group.apexcharts-active {
    padding: 0 12px;
}
</style>